/* import __COLOCATED_TEMPLATE__ from './button-dropdown.hbs.js'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { EnablementStatus } from '@square/dashboard-protos/models/squareup/channelcontrols/configuration/enums';

// Location ID => intended state for enablement to be updated to
let ButtonDropdown = (_dec = computed('selectedLocations.length', 'cashLocalProfile.prepTimesByLocation'), _dec2 = computed('cashLocalProfile.locationConfigurations', 'selectedLocations.[]'), _class = class ButtonDropdown extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "cashLocalProfile", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "store", _descriptor5, this);
    _initializerDefineProperty(this, "userRailsPermissions", _descriptor6, this);
    _initializerDefineProperty(this, "currentLocationModalOnNext", _descriptor7, this);
    _initializerDefineProperty(this, "isLocationModalOpen", _descriptor8, this);
    _initializerDefineProperty(this, "isPrepTimeModalOpen", _descriptor9, this);
    _initializerDefineProperty(this, "selectedLocations", _descriptor10, this);
    _initializerDefineProperty(this, "modalContext", _descriptor11, this);
    _initializerDefineProperty(this, "showDropDown", _descriptor12, this);
    _defineProperty(this, "activeSubunits", []);
  }
  get showCompleteProfileSetup() {
    return this.cashLocalProfile.isProfileSetupNeeded;
  }
  get initialPrepTime() {
    if (this.selectedLocations.length === 0) {
      return '';
    }
    return this.cashLocalProfile.prepTimesByLocation[this.selectedLocations[0]];
  }
  get profileUrl() {
    return this.cashLocalProfile.cleanProfileUrl || '';
  }
  get disableDropdownControlsListProp() {
    return this.showCompleteProfileSetup;
  }
  get size() {
    return this.args.size ?? 'medium';
  }
  get showOrderingStatus() {
    return this.args.showOrderingStatus ?? false;
  }
  get eventLocation() {
    return this.args.eventLocation || '';
  }
  trackLocalProfilesEvent(activity, event, additionalParams = {}) {
    this.dataApi.track(event, {
      activity,
      event,
      feature: 'Local Profiles',
      params: {
        brand_token: this.cashLocalProfile.brandToken || '',
        event_location: this.eventLocation,
        num_locations: this.cashLocalProfile.locationConfigurations.length.toString(),
        ...additionalParams
      }
    });
  }
  openLocationModal(context = 'ordering') {
    this.modalContext = context;
    this.isLocationModalOpen = true;
  }
  openPrepTimeModal() {
    this.trackPrepTimeModalOpen();
    this.isPrepTimeModalOpen = true;
  }
  trackPrepTimeModalOpen() {
    this.trackLocalProfilesEvent('Manage Profile Fulfillment', 'View Local Profile Prep Time Modal', {
      fulfillment_type: 'prep_time'
    });
  }
  trackPrepTimeModalSave() {
    this.trackLocalProfilesEvent('Manage Profile Fulfillment', 'Click Local Profile Prep Time Modal Edit Prep Time', {
      unit_tokens: this.selectedLocations.join(',') || '',
      fulfillment_type: 'prep_time'
    });
  }
  resetDataForSharedModal() {
    this.currentLocationModalOnNext = null;
    this.selectedLocations = [];
  }
  cashLocalDropdownOpened() {
    this.trackLocalProfilesEvent('Manage Profile', 'View Local Profile Management Modal');
  }
  handlePrepTimeModalFlow() {
    this.resetDataForSharedModal();
    if (this.cashLocalProfile.allSubunits.length <= 1) {
      this.selectedLocations = [this.cashLocalProfile.allSubunits[0].token];
      this.openPrepTimeModal();
    } else {
      this.openLocationModal('prep-time');
      this.currentLocationModalOnNext = selectedLocations => {
        this.selectedLocations = selectedLocations || [];
        this.closeLocationModal();
        this.openPrepTimeModal();
      };
    }
  }
  handleOrderingModalFlow() {
    this.resetDataForSharedModal();
    if (this.cashLocalProfile.allSubunits.length === 0) {
      return;
    }
    if (this.cashLocalProfile.allSubunits.length === 1) {
      // For single location, skip modal and directly manage ordering
      if (this.cashLocalProfile.isAllLocationOrderingPaused) {
        this.selectedLocations = [this.cashLocalProfile.allSubunits[0].token];
        this.updateOrdering(false, this.convertSubunitsToLocationConfigurations());
      } else {
        this.updateOrdering(false, this.convertSubunitsToLocationConfigurations());
      }
    } else {
      // Set initially selected locations
      this.selectedLocations = this.cashLocalProfile.allSubunits.filter(location => location.isOrderingAllowed).map(location => location.token);
      this.openLocationModal('ordering');
      this.currentLocationModalOnNext = () => {
        this.closeLocationModal();
        this.updateOrdering(false, this.convertSubunitsToLocationConfigurations());
      };
    }
  }
  handlePickup() {
    this.resetDataForSharedModal();
    if (this.cashLocalProfile.allSubunits.length === 0) {
      return;
    }
    if (this.cashLocalProfile.allSubunits.length === 1) {
      // For single location, skip modal and directly toggle pickup
      const locationId = this.cashLocalProfile.allSubunits[0].token;
      const currentEnablement = this.cashLocalProfile.fulfillmentPickupEnablementByLocation[locationId];
      const updatedEnablement = !(currentEnablement === EnablementStatus.ENABLED);
      this.cashLocalProfile.updateLocationsPickupEnabled({
        [locationId]: updatedEnablement
      });
    } else {
      // Set initially selected locations
      this.selectedLocations = this.cashLocalProfile.fulfillmentLocationsWithPickupEnabled;
      this.openLocationModal('pickup');
      this.currentLocationModalOnNext = () => {
        this.closeLocationModal();
        const locationsToUpdate = this.cashLocalProfile.allSubunits.reduce((result, location) => {
          // Filter out locations where the enablement already matches the intended update
          const intendedEnabled = this.selectedLocations.includes(location.token);
          const intendedEnablement = intendedEnabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED;
          if (intendedEnablement === this.cashLocalProfile.fulfillmentPickupEnablementByLocation[location.token]) {
            return result;
          }
          return {
            ...result,
            [location.token]: intendedEnabled
          };
        }, {});
        this.cashLocalProfile.updateLocationsPickupEnabled(locationsToUpdate);
      };
    }
  }
  handleDelivery() {
    this.resetDataForSharedModal();
    if (this.cashLocalProfile.allSubunits.length === 0) {
      return;
    }
    if (this.cashLocalProfile.allSubunits.length === 1) {
      // For single location, skip modal and directly toggle delivery
      const locationId = this.cashLocalProfile.allSubunits[0].token;
      const currentEnablement = this.cashLocalProfile.fulfillmentDeliveryEnablementByLocation[locationId];
      const updatedEnablement = !(currentEnablement === EnablementStatus.ENABLED);
      this.cashLocalProfile.updateLocationsDeliveryEnabled({
        [locationId]: updatedEnablement
      });
    } else {
      // Set initially selected locations
      this.selectedLocations = this.cashLocalProfile.fulfillmentLocationsWithDeliveryEnabled;
      this.openLocationModal('delivery');
      this.currentLocationModalOnNext = () => {
        this.closeLocationModal();
        const locationsToUpdate = this.cashLocalProfile.allSubunits.reduce((result, location) => {
          // Filter out locations where the enablement already matches the intended update
          const intendedEnabled = this.selectedLocations.includes(location.token);
          const intendedEnablement = intendedEnabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED;
          if (intendedEnablement === this.cashLocalProfile.fulfillmentDeliveryEnablementByLocation[location.token]) {
            return result;
          }
          return {
            ...result,
            [location.token]: intendedEnabled
          };
        }, {});
        this.cashLocalProfile.updateLocationsDeliveryEnabled(locationsToUpdate);
      };
    }
  }
  convertSubunitsToLocationConfigurations() {
    return this.cashLocalProfile.convertSubunitsToLocationConfigurations(this.selectedLocations);
  }
  get selectedLocationConfigurations() {
    // This will go away
    return this.cashLocalProfile.locationConfigurations.filter(location => this.selectedLocations.includes(location.unit_token));
  }
  updateOrderingPause(isPaused) {
    this.updateOrdering(isPaused, []);
  }
  closeLocationModal() {
    this.modalContext = '';
    this.isLocationModalOpen = false;
  }
  closePrepTimeModal() {
    this.isPrepTimeModalOpen = false;
  }
  savePrepTime(saveValue) {
    this.trackPrepTimeModalSave();
    return this.cashLocalProfile.savePrepTime(this.selectedLocations, saveValue);
  }
  updateSelectedLocations(selections) {
    this.selectedLocations = selections;
  }
  handleCompleteProfile() {
    this.router.transitionTo('/ordering-profile/overview');
  }
  async updateOrdering(orderingPaused, locations) {
    await this.cashLocalProfile.updateOrderingConfiguration(orderingPaused, locations);

    // Update on parent component
    this.args.onOrderingConfigurationUpdate?.(this.cashLocalProfile.isAllLocationOrderingPaused);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cashLocalProfile", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userRailsPermissions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentLocationModalOnNext", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isLocationModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isPrepTimeModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedLocations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "modalContext", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'ordering';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showDropDown", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "initialPrepTime", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "initialPrepTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handlePrepTimeModalFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handlePrepTimeModalFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOrderingModalFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOrderingModalFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handlePickup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handlePickup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDelivery", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDelivery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "convertSubunitsToLocationConfigurations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "convertSubunitsToLocationConfigurations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedLocationConfigurations", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "selectedLocationConfigurations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateOrderingPause", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateOrderingPause"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeLocationModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeLocationModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closePrepTimeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closePrepTimeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savePrepTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "savePrepTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSelectedLocations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSelectedLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCompleteProfile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCompleteProfile"), _class.prototype), _class);
export { ButtonDropdown as default };